import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { environment } from '@app-environments/environment';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import { UserService } from '@app-services/user/user.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { UserFeedbackPopupComponent } from '../../shared/components/user-feedback-popup/user-feedback-popup.component';

@Component({
  selector: 'app-self-learn-video-playback',
  templateUrl: './self-learn-video-playback.component.html',
  styleUrls: ['./self-learn-video-playback.component.css']
})
export class SelfLearnVideoPlaybackComponent implements OnInit {
  @ViewChild('video') videoComp: any;
  userLikeStatus:boolean = false;
  userDislikeStatus:boolean = false;
  playlists:any = [];
  videoFullData:any ;
  videoDetailsPlayList:any;
  currentPlayListIndex:any;
  currentVideoPosition = 0;
  isVideoCompleted = false;
  subjectIcon:any;
  isVideoLsqSent: boolean = true;
  userData: any;
  watchedInSec;
  videoLikeCount: any;

  constructor(public dialog: MatDialog, public router: Router, public selfLearnService:SelfLearnService, public spinner:NgxSpinnerService,private firebaseService: FirebaseService,private userService: UserService,) { }

  ngOnInit(): void {
    this.userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
    const videoId = localStorage.getItem("selfLearnSelectedVideoId");
    const isFromChapterScreen = (localStorage.getItem("selfLearnPreviousPage") == 'chapter') || (localStorage.getItem("selfLearnPreviousPage") == 'subject') ? true : false;
    this.getVideoData(videoId);
    if(isFromChapterScreen){
   
      if(localStorage.getItem("selfLearnSelectedPlayList") && localStorage.getItem("selfLearnSelectedPlayName")){
        this.getPlayList();
      }else {
        this.getTopicsAndVideosForExamChapterSubtenant();
      }
    }else if(localStorage.getItem("selfLearnPreviousPage")=='selfLearn-V2/practice-questions' ||localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/revise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/exercise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/pyp-chapter-questions' || localStorage.getItem("selfLearnPreviousPage")=='selfLearn-V2/exercise-solution'){
      this.getVideoProgressForSolutionVideo(videoId);
    }
    else this.getPlayList();
  }

  getPlayList(){
    const playListId = localStorage.getItem('selfLearnSelectedPlayList');
    const videoId = localStorage.getItem("selfLearnSelectedVideoId");
    const isFromChapterScreen = (localStorage.getItem("selfLearnPreviousPage") == 'chapter') || (localStorage.getItem("selfLearnPreviousPage") == 'subject')? true : false;
    const params = {
      examId: this.selfLearnService.getCmsExamID(),
      subTenantId: this.selfLearnService.getSubtenantId(),
      playlistTypeId: playListId,
    }
    this.selfLearnService.getVideosByPlayListId(params).subscribe((resp:any) => {
      let videos:any;
      this.playlists= [];
      videos = resp.data
      videos.map((item:any) => {
        item.videos.map((video:any) => {
          this.playlists.push(video);
        })

      })
      //this.playlists = resp.data[0].videos;
      this.getVideosDetailForPlayListId(playListId, videoId);
      if(isFromChapterScreen) {this.getVideoProgressByTopic()};
    })
  }

    getVideoProgressByTopic(videoId?:any){
      this.selfLearnService.getVideoProgressByTopic().subscribe((resp:any) => {
        this.playlists = this.playlists.map((video:any) => {
          const found = resp?.data?.find((element:any) => video.videoId == element.videoId);
         
          if(found){video['completed'] = found.isCompleted;
            video['isBookmarked'] = found.isBookmarked;
            video['watchedContentInSecs'] = found.watchedContentInSecs;
            video['isLiked'] = found?.isLiked
            video['isDisliked'] = found.isDisliked

          }
          else{
            video['completed'] = false;
            video['isBookmarked'] = false;
            video['isLiked'] = false
            video['isDisLiked'] = false
        }
          return video;
        })
        if(videoId){this.setPlayListIndex(videoId)};
    })
  }

  userLike(){
    let index:any =this.playlists.findIndex((item:any) => item.videoId == this.videoFullData.videoId)
    this.playlists[index].isLiked = true;
    this.playlists[index].isDisliked = false;
    this.userLikeStatus = !this.userLikeStatus;

    let payload:any = this.constructPayloadforLikeandDislike();
    this.selfLearnService.storeVideoProgress(payload).subscribe((resp:any) => {
      this.getVideoLikeCount(this.videoFullData.videoId);
    })
  }
  userDislike(){
    let index:any =this.playlists.findIndex((item:any) => item.videoId == this.videoFullData.videoId)
    this.playlists[index].isDisliked = true;
    this.playlists[index].isLiked = false;
    this.userDislikeStatus = !this.userDislikeStatus;
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
      data: {assetType:"video"}
    });
    
    dialogRef.afterClosed().subscribe(() => {
    });

    
    let payload:any = this.constructPayloadforLikeandDislike();
    this.selfLearnService.storeVideoProgress(payload).subscribe((resp:any) => {
      this.getVideoLikeCount(this.videoFullData.videoId);
    })
  }

  navigateToPreviousPage(){
    let previousPage ; 
    let isFromHomeScren = localStorage.getItem('isFromHomeScreen');
    isFromHomeScren == "true" ?  localStorage.getItem('previousScreen')? previousPage = localStorage.getItem('previousScreen'): previousPage='home' : previousPage = localStorage.getItem("selfLearnPreviousPage");
  
    let navigationPath;
    switch (previousPage) {
      case 'home':
        navigationPath = 'selfLearn-V2';
        break;
      case 'chapter':
        navigationPath = 'selfLearn-V2/chapter';
        break;
      case 'subject':
          navigationPath = 'selfLearn-V2/subject';
          break;
      case 'selfLearn-V2/bookmarks':
            navigationPath = 'selfLearn-V2/bookmarks';
            break;
      case 'selfLearn-V2/my-library':
          navigationPath = 'selfLearn-V2/my-library';
          break;
      case 'selfLearn-V2/practice-questions':
          localStorage.setItem('isItFromVideoSolution','true');
          navigationPath = 'selfLearn-V2/practice-questions';
          break;
      case 'selfLearn-V2/revise-questions':
        localStorage.setItem('isItFromVideoSolution','true');
           navigationPath = 'selfLearn-V2/revise-questions';
           break;
      case 'selfLearn-V2/exercise-questions':
           localStorage.setItem('isItFromVideoSolution','true');
           navigationPath = 'selfLearn-V2/exercise-questions';
           break;
      case 'selfLearn-V2/pyp-chapter-questions':
            localStorage.setItem('isItFromVideoSolution','true');
            navigationPath   = 'selfLearn-V2/pyp-chapter-questions';
            break;
      case 'selfLearn-V2/my-history':
          navigationPath = 'selfLearn-V2/my-history';
          break;
      case  'selfLearn-V2/exercise-solution':
          navigationPath = 'selfLearn-V2/exercise-solution';
          break;
      default:
        navigationPath = 'selfLearn-V2/videos';
        break;
    }
    localStorage.removeItem('isFromHomeScreen');
    if(this.watchedInSec >= 15){
      this.sendLsqData(this.watchedInSec);
     }
    this.router.navigateByUrl(navigationPath);
  }

  onVideoSelected(videoData:any){
    this.getVideoData(videoData.videoId, true);
    this.resetVideoStatus();
  }

  videoEnded(){
    ++this.currentPlayListIndex;
    this.resetVideoStatus()
    this.playNextVideo();
  }

  getVideoData(videoId:any, callSetPlayListIndex?:boolean){
    this.spinner.show();
    this.getVideoLikeCount(videoId);
    this.selfLearnService.getVideoCms(videoId).subscribe((resp:any) => {
      this.videoFullData = { ...resp?.video }
      localStorage.setItem("selfLearnSelectedVideoId", this.videoFullData.videoId);
      if(localStorage.getItem("selfLearnPreviousPage")=='selfLearn-V2/practice-questions' ||localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/revise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/exercise-questions' || localStorage.getItem("selfLearnPreviousPage")== 'selfLearn-V2/pyp-chapter-questions'){
        this.getVideoProgressForSolutionVideo(videoId);
      }
      this.spinner.hide();
      if(callSetPlayListIndex){setTimeout(() => {
        this.setPlayListIndex(videoId)
      }, 500);}
      // this.videoFullData.videoURL = (this.videoFullData.videoURL).replace('https://', 'http://');
    })
  }

  playNextVideo(){
    const nextVideo = this.playlists[this.currentPlayListIndex];
    this.getVideoData(nextVideo.videoId, true);
    this.playlists[this.currentPlayListIndex].resume = true;
  }

  setPlayListIndex(videoId:any){
    for (let index = 0; index < this.playlists.length; index++) {
      const element = this.playlists[index];
      if(element.videoId == videoId){
        this.currentPlayListIndex = index;
        this.playlists[index].resume = true;
        if(element.watchedContentInSecs && !element.completed){this.setVideoSeekTime(element.watchedContentInSecs);}
        return;
      }
    }
  }

  setVideoSeekTime(seconds:any){
    this.videoComp.nativeElement.currentTime = seconds;
  }


  resetVideoStatus(){
    this.playlists.forEach((video:any) => {
      video.resume = false;
   });
   this.currentVideoPosition = 0;
   this.isVideoCompleted = false;
   if(this.watchedInSec >= 15){
    this.sendLsqData(this.watchedInSec);
   }
  }

  getVideosDetailForPlayListId(playListId:any, videoId:any){
    this.selfLearnService.getVideoDetailsForPlatListTypeId(playListId).subscribe((resp:any) => {
      this.videoDetailsPlayList = resp.videos;
      this.setVideoDetailsForPlayList(videoId);
    })
  }

  setVideoDetailsForPlayList(videoId:any){
   this.playlists.forEach((playList:any) => {
    this.videoDetailsPlayList.forEach((element:any) => {
      if(playList.videoId == element?.videoId){
        playList['completed'] = element?.isCompleted;
        playList['watchedContentInSecs'] = element.watchedContentInSecs;
        playList['isBookmarked'] = element?.isBookmarked;
        playList['isLiked'] = element?.isLiked
        playList['isDisliked'] = element?.isDisLiked

      }
    });
    this.setPlayListIndex(videoId);
   });
  }

   getTopicsAndVideosForExamChapterSubtenant(){
    const chapterId = localStorage.getItem("chapterId");
    const topicId = localStorage.getItem("selfLearnSelectedTopicId");
    const videoId = localStorage.getItem("selfLearnSelectedVideoId");
    this.selfLearnService.getTopicsAndVideosForExamChapterSubtenant(chapterId).subscribe((resp:any) => {
      this.subjectIcon = resp?.data?.parent?.icon;
      this.playlists = resp?.data?.child.filter((topic:any) => topic.topicId == topicId)[0].videos;
      this.getVideoProgressByTopic(videoId);
    })
  }

  dispatchEventsOnTimeUpdate(event:any){
    if(this.selfLearnService.isFromLearn() && event.srcElement.currentTime > 16 && this.isVideoLsqSent == true){
      this.isVideoLsqSent = false;
    }
    const currentVideoPosition = (event.srcElement.currentTime.toFixed(2) / event.srcElement.duration) * 100;
     this.watchedInSec = event.srcElement.currentTime.toFixed(2);
    if(((event.srcElement.currentTime - this.currentVideoPosition) > 30 || currentVideoPosition >= 85) && !this.isVideoCompleted){
      this.storeVideoProgress(currentVideoPosition, this.watchedInSec);
      if(currentVideoPosition >= 85){this.isVideoCompleted = true}
      this.currentVideoPosition = event.srcElement.currentTime;
    }
  }

  storeVideoProgress(currentVideoPosition:any, watchedInSec:any){
    if(localStorage.getItem("selfLearnSelectedPlayName") == 'Recommended'){
      this.getSubjectIdOfRecomendedVideos( Number(this.selfLearnService.getVideoId()));
    }
    if(localStorage.getItem('previousScreen') !='selfLearn-V2/bookmarks' && localStorage.getItem('previousScreen') !='selfLearn-V2/my-library' && localStorage.getItem('previousScreen') != 'selfLearn-V2/my-library'){ //we are not allowed to hit progress API when it video from my-library
      let storeVideoProgressPayLoad :any =  this.constructJsonForStoreVideoProgress(currentVideoPosition, watchedInSec)
      this.selfLearnService.storeVideoProgress(storeVideoProgressPayLoad).subscribe((resp:any) => {
        if(resp && currentVideoPosition > 85){this.playlists[this.currentPlayListIndex].completed = true}
        if(localStorage.getItem("selfLearnSelectedPlayName") == 'Recommended'){
          localStorage.removeItem("selfLearnSelectedSubject");
        }
      })
    }

  }
  getSubjectIdOfRecomendedVideos(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video.videoId == videoId)
     console.log(videoData);
     localStorage.setItem("selfLearnSelectedSubject" , videoData.subjects[0].subjectId);
    
   }
   isVideoBookMarked(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video?.videoId == videoId)
      return videoData?.isBookmarked;
    
   }
   isVideoLiked(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video?.videoId == videoId)
    return videoData?.isLiked;
   }
   isVideoDisLiked(videoId:any){
    let videoData:any = this.playlists.find((video:any) => video?.videoId == videoId)
    return videoData?.isDisliked;
   }

  constructJsonForStoreVideoProgress(currentVideoPosition:any, watchedInSec:any){
    return {
      examId: Number(this.selfLearnService.getCmsExamID()),
      gradeId: this.selfLearnService.getGradeId(),
      subjectId: Number(this.selfLearnService.getSubjectId()),
      chapterId: Number(this.selfLearnService.getChapterId()),
      chapterName:this.selfLearnService.getChapterName(),
      topicId: Number(this.selfLearnService.getTopicId()),
      playlistTypeId: Number(this.selfLearnService.getPlayListId()),
      topicName: localStorage.getItem('selectedTopicName'),
      videoId: Number(this.selfLearnService.getVideoId()),
      videoName: (this.videoFullData.title),
      watchedContentInSecs: Number(watchedInSec),
      isCompleted: (currentVideoPosition >= 85) ? true : false,
      isBookmarked: this.isVideoBookMarked(this.videoFullData.videoId),
      isLiked: this.isVideoLiked(this.videoFullData.videoId),
      isDisLiked: this.isVideoDisLiked(this.videoFullData.videoId)
    };
  }
  constructPayloadforLikeandDislike(){
    return {
      examId: Number(this.selfLearnService.getCmsExamID()),
      gradeId: this.selfLearnService.getGradeId(),
      subjectId: Number(this.selfLearnService.getSubjectId()),
      chapterId: Number(this.selfLearnService.getChapterId()),
      chapterName:this.selfLearnService.getChapterName(),
      topicId: Number(this.selfLearnService.getTopicId()),
      playlistTypeId: Number(this.selfLearnService.getPlayListId()),
      topicName: localStorage.getItem('selectedTopicName'),
      videoId: Number(this.selfLearnService.getVideoId()),
      videoName: (this.videoFullData.title),
      isBookmarked: this.isVideoBookMarked(this.videoFullData.videoId),
      isLiked: this.isVideoLiked(this.videoFullData.videoId),
      isDisLiked: this.isVideoDisLiked(this.videoFullData.videoId)
    };
  }

  sendLsqData(watchTime: any) {
    let payload={
      data:{
      video_study_video : this.videoFullData.title,
      video_duration_watched : watchTime,
      video_subject:this.selfLearnService.getSubjectName(),
      video_chapter:this.selfLearnService.getChapterName()
      },
      landingPage : "LSQ_CUSTOM_EVENTS"
    }
    let  mPayload={}
    // console.log(payload);
    // isUserAdmin(this.userService).then((bool) => {
      // if(!bool) {
        // this.selfLearnService.callTrackingAPI2(payload,'Act_Self_Learn_Video').subscribe((data)=>{console.log(data);
        // })
      // }
    // })
    this.firebaseService.getSqsValue().then((firebaseRSP) => {
      mPayload = {
        mx_Custom_1 : this.videoFullData.title,
        mx_Custom_2 : watchTime,
        mx_Custom_3:localStorage.getItem('selfLearnSelectedSubjectName'),
        mx_Custom_4:localStorage.getItem("chapterName")
      }
      this.userService.sendSQSMsgOptim(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,mPayload,264);
    }).catch((e) => {
      console.log(e);
    });
  }

  //to get video solutuion progress
getVideoProgressForSolutionVideo(videoId:any){
    this.selfLearnService.getVideoProgressForSolutionVideo(videoId).subscribe((res:any)=>{
      this.videoFullData.isBookmarked = res?.isBookmarked ? res?.isBookmarked : false
      this.videoFullData.isCompleted = res?.isCompleted ? res?.isComplete : false
      this.videoFullData.isLiked = res?.isLiked ? res?.isLiked : false
      this.videoFullData.isDisliked = res?.isDisLiked ? res?.isDisLiked : false
      this.videoFullData.watchedContentInSecs = res?.watchedContentInSecs ? res?.watchedContentInSecs : false
      if( this.playlists.length <=0){
        this.playlists.push(this.videoFullData);
      }
      this.setVideoSeekTime(res.watchedContentInSecs);
    })
}
getVideoLikeCount(videoId:any){
  this.selfLearnService.getVideoLikeCount(videoId).subscribe((res:any) => {
    this.videoLikeCount = res.likeCount;
    console.log(res)
  })
}
}
